import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Reports/";
const reportAPIService = new APIService(baseUrl);

export async function GetReportList(args) {
  //console.log(args);
  var url = "getallorderreport";
  return await reportAPIService.postData(url, args);
}

// Report Details By ID API
export async function GetCustomerReport(mappingid) {
  var url = "getcustomerreportbyid?mappingid=" + mappingid;
  return await reportAPIService.fetchData(url);
}

export async function GetReportTemplate() {
  var url = "getallreporttemplates";
  return await reportAPIService.fetchData(url);
}

export async function AddCustomerReport(report) {
  var url = "addcustomerreport";
  return await reportAPIService.putData(url, report);
}

export async function UpdateCustomerReport(report) {
  var url = "updatecustomerreport";
  return await reportAPIService.patchData(url, report);
}

export async function DeleteCustomerReport(reportId) {
  var url = "deleteCustomerReport?reportid=" + reportId;
  return await reportAPIService.deleteData(url);
}

export async function AssignReportTemplate(data) {
  var url = "assignreporttocustomer";
  return await reportAPIService.postData(url, data);
}

export async function GetCustomerAllReports(customerid) {
  //console.log(customerid);
  var url = "getcustomerallreport?customerid=" + customerid;
  return await reportAPIService.fetchData(url);
}

export async function GetInvestigatorAllReports(investigatorid) {
  var url = `getinvestigatorallreport?investigatorid=${investigatorid}`;
  return await reportAPIService.fetchData(url);
}

export async function GetQAAllReports(qaid) {
  var url = `getqaallreport?qaid=${qaid}`;
  return await reportAPIService.fetchData(url);
}

export async function GetReportTemplateById(id) {
  var url = "getreporttemplatebyid?templateid=" + id;
  return await reportAPIService.fetchData(url);
}

export async function GetReportDetail(mappingid, mode) {
  //console.log(mode);
  var customHeader = {};
  if (mode != null) {
    customHeader = {
      Mode: mode,
    };
  }
  var url = "getreportdetail?mappingid=" + mappingid;
  return await reportAPIService.fetchData(url, customHeader);
}

export async function UpdateReportDetail(data) {
  var url = "updatereportdetail";
  return await reportAPIService.patchData(url, data);
}

export async function GetAllReports() {
  var url = "getallreports";
  return await reportAPIService.fetchData(url);
}

export async function GetHistoricalReports(args) {
  var url = "gethistoricalreports";
  return await reportAPIService.postData(url, args);
}
